import { render, staticRenderFns } from "./rich.vue?vue&type=template&id=6773c45b&scoped=true"
import script from "./rich.vue?vue&type=script&setup=true&lang=js"
export * from "./rich.vue?vue&type=script&setup=true&lang=js"
import style0 from "./rich.vue?vue&type=style&index=0&id=6773c45b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773c45b",
  null
  
)

export default component.exports